<section id="fund-management">
    <div class="container" id="fund-management_section">
        <div class="row">
            <div class="col-md-8">
                <h2 class="fund-mng-title rps-heading-two" id="fund-management_header" >Fund management</h2>
            </div>
        </div>
        <div *ngIf="!fundManagementModel?.is529">
            <div *ngIf="fundManagementModel?.investmentProcess;else mdash">
                <div class="row fm-content">
                    <div class="col-md-12 content mb-10 pt-20 rps-paragraph-one">
                        <div [innerHTML]="fundManagementModel.investmentProcess"></div>
                    </div>
                </div>
                <div class="row accor-div">
                    <div class="col-sm-12">
                        <div *ngFor="let data of managementDetails.managementCompanies;let i = index">
                            <div><strong class="heading-accor rps-heading-five-greyed">{{data.name}}</strong></div>
                            <div class="rps-paragraph-one container-spacing" [innerHTML]="data.description"></div>
                            <div class="container-flex">
                                <div *ngFor="let advisor of data.advisors" class="advisor-container">
                                    <div class="overhead-marker"></div>
                                    <div class="advisor-name">{{advisor.name}}</div>
                                    <div class="advisor-credentials" [innerHTML]="advisor.credentials"></div>
                                    <div class="advisor-description" [innerHTML]="advisor.description"></div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <ng-template #mdash>
                <h4 class="rps-heading-four">&mdash;</h4>
            </ng-template>
        </div>
        <div class="row" *ngIf="fundManagementModel?.is529">
          <p [innerHTML]="portfolioAdvisoryStructure?.contentValue"></p>
        </div>
    </div>
    <ng-container   >
        <vmf-constellation-video *ngIf="fundVideoList[ticker]" [youtubeId]="fundVideoList[ticker]" ></vmf-constellation-video>
    </ng-container>
</section>
